

export default class Vector2 {
  constructor(x = 0,y = 0) {
    this.x = x;
    this.y = y;
  }

  get_x(){
    return this.x;
  }
  get_y(){
    return this.y;
  }
}



// WEBPACK FOOTER //
// ./src/engine/Vector2.js